<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes contianer">
          <div class="item"  v-for="item in combinedArray" :key="item.id">
            <div class="vatar">
              <el-avatar icon="el-icon-user-solid" :size="size" :src="item.avatar"></el-avatar>
              <div class="textarea" :style="item.intention * 1 === 1 ? 'background-color:#28ab3f' : ''">{{item.intention * 1 === 1 ? '有意向' : '无意向'}}</div>
            </div>
            <div class="con">
              <div class="text">
                <div class="name"><span>姓名：</span>{{item.nickname}}</div>
                <div class="num"><span>年龄：</span>{{item.age}}</div>
              </div>
              <div class="age">
                <div class="sex"><span>性别：</span>{{item.sex}}</div>
                <el-button type="primary" @click="addToEvalua(item)">
                  加入测评
                </el-button>
              </div>
              <div class="age" style="margin-top: 0.4rem">
                <div class="sex"><span>监护人：</span>{{item.real_name}}（<span @click="makeCall(item.mobile)">{{item.mobile}}</span>）</div>
                <el-button type="primary" @click="fetchRecords(item)">
                  跟踪记录
                </el-button>
              </div>
            </div>
          </div>
          <el-empty v-if="combinedArray.length === 0" description="暂无数据"></el-empty>
        </div>

        <!-- <div v-if="showModal" class="modal">
          <div class="modal-content">
            <span class="close" @click="showModal = false">&times;</span>
            <CustomerFollowUp :records="records"  @add-record="addRecord"   />
          </div>
        </div> -->
        <el-dialog :visible.sync="showModal" width="88%" title="客户跟踪记录">
          <div class="modal-content">
            <CustomerFollowUp :student="curStudent" :records="records" @open-form="dialogVisible = true"  @update-value="updateValue" /><!-- @add-record="addRecord" -->
          </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible" title="新增记录">
          <NewRecordForm :student="curStudent" @submit="handleAddRecord" @close="dialogVisible = false" />
        </el-dialog>
    </div>
</template>
<script>
import { getUserList, getFollowLogList, saveFollowLog, userEdit } from '@/api/app'
import { Loading } from 'element-ui'
import CustomerFollowUp from '../components/CustomerFollowUp.vue'
import NewRecordForm from '../components/NewRecordForm.vue'
export default {
  name: 'Track',
  components: {
    CustomerFollowUp,
    NewRecordForm
  },
  data () {
    return {
      column: '等待测评',
      size: 'large',
      autoSaveMessage: false,
      showModal: false,
      records: [],
      page_no: 1,
      loading: false,
      noMoreData: false,
      items: [],
      fDatas: {},
      dialogVisible: false,
      curStudent: {}
    }
  },
  computed: {
    // 计算属性，用于合并数组
    combinedArray () {
      return [...this.items]
    }
  },
  mounted () {
    // this.setDataInit()
    this.fetchData()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    /* autoSaveForm () {
      // console.log('Auto-saving form data...', this.combinedAndSortedArray)
      this.autoSaveMessage = true
      setTimeout(() => {
        this.autoSaveMessage = false
      }, 2000)
    }, */
    addToEvalua (item) {
      // 提交测评的逻辑
      this.$confirm('当前学生【' + item.nickname + '】' + '，确定加到待测评吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 跳转到测评页面
        await userEdit({
          id: item.id,
          field: 'status',
          value: 5
        })
        this.$router.push('/student?status=5')
      }).catch(() => {
        // 用户点击了取消按钮，或者关闭了确认框
        console.log('用户取消了操作')
      })
    },
    async fetchData () {
      if (this.fDatas.count) {
        if (this.fDatas.count === this.items.length || this.fDatas.count < this.fDatas.page_size) {
          this.noMoreData = true
          // console.log('====小于1页====')
          return
        }
      }
      /* this.$message({
            message: '没有更多数据了',
            type: 'warning'
          }) */
      //  状态:0-等待测评,1-等待报告,2-查看报告
      let params = {
        page_no: this.page_no,
        page_size: 20
      }
      /* switch (this.activeName) {
        case 'first':
          break
        case 'second':
          params['status'] = [5]
          break
        case 'third':
          params['status'] = [8]
          break
        case 'fourth':
          params['status'] = [11]
          break
      } */
      params['status'] = [0]
      /* // 如果是从home点击的，需要带上status参数
      if (this.queryStatus) {
        switch (this.queryStatus) {
          case '88':
            params['status'] = [8, 11]
            break
          default:
            params['status'] = [this.queryStatus * 1]
            break
        }
      } */
      // 显示加载层
      this.loadingInstance = Loading.service({ fullscreen: true })
      this.fDatas = await getUserList(params)
      this.loadingInstance && this.loadingInstance.close()
      const newItems = this.fDatas.lists.map(item => {
        // 创建一个新的对象，避免直接修改原数组
        const newItem = { ...item }
        // console.log(newItem)
        // 根据 sex 的值来修改显示
        if (newItem.sex * 1 === 1) {
          newItem.sex = '男'
        } else if (newItem.sex * 1 === 2) {
          newItem.sex = '女'
        }
        return newItem
      })
      // console.log(newItems)
      if (newItems.length === 0) {
        this.noMoreData = true
      } else {
        this.items = [...this.items, ...newItems]
        this.page_no++
      }
    },
    async fetchRecords (item) {
      // console.log(item)
      this.records = []
      const params = {
        student_id: item.id
      }
      this.curStudent = item
      this.showModal = true
      this.records = await getFollowLogList(params)
      /* this.records = [{
          id: 1,
          customerName: '张三',
          mobile: '12345678901',
          followDate: '2024-09-01',
          content: '初次联系，了解需求。'
        }] */
    },
    makeCall (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`
    },
    async addRecord (newRecord) {
      newRecord['student_id'] = this.curStudent.id
      const result = await saveFollowLog(newRecord)
      // console.log(result)
      this.records.unshift(result[0])
    },
    handleAddRecord (record) {
      this.addRecord(record)
      this.dialogVisible = false // 关闭对话框
    },
    async updateValue (newValue) {
      // console.log('====1', newValue, this.curStudent.intention)
      // 跳转到测评页面
      await userEdit({
          id: this.curStudent.id,
          field: 'intention',
          value: newValue
        })
      this.curStudent.intention = newValue // 更新父组件的值
      // console.log('====2', this.curStudent.intention)
    }
  },
  watch: {
    /* combinedAndSortedArray: {
      handler (newValue) {
        this.autoSaveForm()
      },
      deep: true
    } */
  }
}
</script>
<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: white;
  /* padding: 20px; */
  border-radius: 5px;
  width: 100%;
  /* max-width: 600px; */
}

.close {
  float: right;
  font-size: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Track.vue